// extracted by mini-css-extract-plugin
module.exports = {"container":"BetonVolume_container__1oyC9","value":"BetonVolume_value__r5e2_","measure":"BetonVolume_measure__2dPMo","divider":"BetonVolume_divider__3-Z2U"};